<div class="bg-primary-color soft--ends relative" style="overflow: hidden;">
    <div class="cf wrapper push--bottom relative">
        <span class="icon icon-info icon--header-background"></span>
        <div class="col small_12" style="position: relative; z-index: 1;">
            <h1 class="tera primary-font push-half--bottom white"  id="main-content" tabindex="0">
                {{pageTitle}}
            </h1>
        </div>
    </div>
    <div class="panel--opacity">
        &nbsp;
    </div>
</div>
<div class="wrapper wrap pb-120 soft--medium pull-up">

    <div class="login-card">
        <form [formGroup]="loginForm" autocomplete="off" (ngSubmit)="onSubmit()">
            <div class="govuk-form-group">
                <label tabindex="0">Email</label>
                <input type="text" class="form-control" formControlName="email" tabindex="0" role="textbox">
                <div *ngIf="submitted && form.email.errors" class="invalid-feedback">
                    <div *ngIf="form.email.errors.required" role="alert" tabindex="0">Email is required</div>
                    <div *ngIf="form.email.errors.pattern" role="alert" tabindex="0">Email must be a valid email address
                    </div>
                </div>
            </div>

            <div class="govuk-form-group">
                <label tabindex="0">Password</label>
                <input type="password" class="form-control" formControlName="password" tabindex="0" role="textbox">
                <div *ngIf="submitted && form.password.errors" class="invalid-feedback">
                    <div *ngIf="form.password.errors.required" role="alert" tabindex="0">Password is required</div>
                </div>
            </div>

            <button type="submit" class="btn btn-primary " role="button">
                Submit
            </button>

        </form>

        <div class="text-center">

            <p class="mt-4">
                <button type="button" class="link" (click)="forgottenPassword()" tabindex="0"
                    aria-label="Forgotten password" role="link">Forgotten password?</button>
            </p>

            <form [formGroup]="resetPasswordForm" (ngSubmit)="resetPassword()" *ngIf="resetPasswordField">
                <div class="row reset-group">
                    <div class=" reset-field-div">
                        <input type="text" class="form-control" formControlName="email" placeholder="Enter email">
                        <div *ngIf="resetLoginSubmitted && resetForm.email.errors" class="invalid-feedback">
                            <div *ngIf="resetForm.email.errors.required" role="alert" tabindex="0">Email is required
                            </div>
                            <div *ngIf="resetForm.email.errors.pattern" role="alert" tabindex="0">Email must be a valid
                                email address</div>
                        </div>
                    </div>

                    <div class="reset-btn-div">
                        <button type="submit" class="btn btn-primary reset-btn">Reset password</button>
                    </div>
                </div>
            </form>

            <p class="mt-4" tabindex="0">If you do not have a login then please register</p>

            <button type="button" class="btn btn-primary" (click)="register()" tabindex="0">
                Register
            </button>

        </div>
    </div>

    <div class="mt-4 login-text-card">
        <div class="login-text text-center" tabindex="0" role="note">
            <span>{{loginPageText}}</span>
        </div>
    </div>

</div>